import { render, staticRenderFns } from "./BfAccount.vue?vue&type=template&id=2fbe2d38&scoped=true"
import script from "./BfAccount.vue?vue&type=script&lang=js"
export * from "./BfAccount.vue?vue&type=script&lang=js"
import style0 from "./BfAccount.vue?vue&type=style&index=0&id=2fbe2d38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbe2d38",
  null
  
)

export default component.exports